module.exports = __webpack_public_path__ + "static/media/life-anona.2d49130e.jpg";